export const FIAT = 'fiat';
export const TOKEN = 'token';